import '../style/contact-us/SendMessage.scss';

const SendMessage=()=>{
  return(
    <div className="SendMessage">
      <div className="SendMessage-name">
        <label  htmlFor="SendMessage-name-input">نام و نام خانوادگی</label>
        <input 
          type="text" 
          className="SendMessage-name-input" 
          name="SendMessage-name-input" 
          id="SendMessage-name-input" 
        />
      </div>
      <div className="SendMessage-email">
        <label  htmlFor="SendMessage-email-input">شماره تماس یا ایمیل</label>
        <input 
          type="text" 
          className="SendMessage-email-input" 
          name="SendMessage-email-input" 
          id="SendMessage-email-input" 
        />
      </div>
      <div className="SendMessage-department">
        <select 
          className="SendMessage-department-select" 
          name="SendMessage-department-select" 
          id="SendMessage-department-select"
        >
          <option value="defult">انتخاب دپارتمان</option>
          <option value="a"> آموزش</option>
          <option value="b"> مالی</option>
          <option value="c"> پشتیبانی</option>
        </select>
      </div>
      <div className="SendMessage-message">
        <textarea 
        placeholder="متن پیام را اینجا بنویسید"
        
        className="SendMessage-message-textarea" 
        name="SendMessage-message-textarea" 
        id="SendMessage-message-textarea" 
        cols="30" rows="10">
        </textarea>
      </div>
      <div className="SendMessage-btn-container">
        <div className="SendMessage-btn-container-btn">ارسال پیام</div>
      </div>
    </div>
  )
}

export default SendMessage;